module.exports = __webpack_public_path__ + "static/media/Plainslogo.3a02b4e3.jpg";